import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { ProductOfferingCostCalculatorPage } from "src/routes/developments/product-offerings/ProductOfferingCostCalculatorPage";
import { ProductOfferingScopePage } from "src/routes/developments/product-offerings/ProductOfferingScopePage";
import { GlobalProductOfferings } from "src/routes/libraries/product-offerings/GlobalProductOfferings";
import { AddProductOfferingPage } from "src/routes/libraries/product-offerings/add-product-offering/AddProductOfferingPage";
import { CheckoutPricingTracePage } from "src/routes/libraries/product-offerings/checkout-pricing-trace/CheckoutPricingTracePage";
import { EditProductOfferingPage } from "src/routes/libraries/product-offerings/edit-product-offering/EditProductOfferingPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import { defineRoute } from "src/routing/defineRoute";

// Path + typed URL builder, defined once and shared by the route tree below and the URL builders in
// `src/RouteUrls.ts`. Full absolute strings (RR6 requires a child's path to start with its parent's).
export const globalProductOfferingsRoute = defineRoute("/libraries/product-offerings");
export const productOfferingRoute = defineRoute("/libraries/product-offerings/:idOrAdd");
export const productOfferingCreateRoute = defineRoute("/libraries/product-offerings/add");
export const productOfferingEditRoute = defineRoute("/libraries/product-offerings/edit/:productOfferingId/:rpavId");
export const productOfferingScopeRoute = defineRoute("/libraries/product-offerings/:productOfferingId/scope/:rpavId");
export const productOfferingCostCalculatorRoute = defineRoute(
  "/libraries/product-offerings/:productOfferingId/cost-calculator/:rpavId",
);
export const productOfferingConfigPricingTraceRoute = defineRoute(
  "/libraries/product-offerings/checkout-pricing-trace/:configId",
);

/**
 * `/libraries/product-offerings/*` route tree (first migrated domain).
 *
 * Role: data router domain route.
 *
 * Default stack: `AppShell` → `AuthenticatedShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page.
 * Legacy `LibrariesLayout` / `Routes.tsx` must not register these paths — see `LibrariesLayout.tsx`.
 *
 * Some pages skip `ScrollableParentLayout` (e.g. scope uses its own side panel). Sibling layout branches
 * (e.g. a future Beam `NavbarLayout` without `PreventBrowserScroll`) nest alongside `GlobalNavLayout`
 * under `AppShell`'s outlet — not under `GlobalNavLayout`.
 */
export const librariesProductOfferingsRoute: RouteObject = {
  path: globalProductOfferingsRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        // `ProductOfferingScopePage` uses its own internal layout to have a left side panel for filtering
        { path: productOfferingScopeRoute.path, Component: ProductOfferingScopePage },
        {
          Component: ScrollableParentLayout,
          children: [
            { index: true, Component: GlobalProductOfferings },
            { path: productOfferingEditRoute.path, Component: EditProductOfferingPage },
            { path: productOfferingCostCalculatorRoute.path, Component: ProductOfferingCostCalculatorPage },
            { path: productOfferingConfigPricingTraceRoute.path, Component: CheckoutPricingTracePage },
            { path: productOfferingCreateRoute.path, Component: AddProductOfferingPage },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
